import React, { useState } from "react";
import DashboardLayout from "../../../components/DashboardLayout";
import JobSingleLayout from "./components/JobSingleLayout";
import JobSingleSearch from "./components/JobSingleSearch";
import { useUserContext } from "../../../Context/UserContext";


const JobSearchPage = () => {
	const { FullJobData, handleJobData } = useUserContext();
 
	// Define breadcrumbs here, after FullJobData is available
	const breadcrumbs = [
		{
			name: "My Jobs",
		},
		{
			name: FullJobData[0]?.name,
		},
		{
			name: "Search Assistant",
		},
	];
	return (
		<>
			<DashboardLayout breadcrumbs={breadcrumbs}>
				<JobSingleLayout>
					<JobSingleSearch />
				</JobSingleLayout>
			</DashboardLayout>
		</>
	);
};



export default JobSearchPage;
